// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/set_project_image_frame_number.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/set_project_image_frame_number.proto.
 */
export const file_vision_assets_v1_set_project_image_frame_number: GenFile = /*@__PURE__*/
  fileDesc("CjV2aXNpb24vYXNzZXRzL3YxL3NldF9wcm9qZWN0X2ltYWdlX2ZyYW1lX251bWJlci5wcm90bxIXcHJvdG9zLnZpc2lvbi5hc3NldHMudjEiywEKIVNldFByb2plY3RJbWFnZUZyYW1lTnVtYmVyUmVxdWVzdBJRCgZwYXJhbXMYASABKAsyQS5wcm90b3MudmlzaW9uLmFzc2V0cy52MS5TZXRQcm9qZWN0SW1hZ2VGcmFtZU51bWJlclJlcXVlc3QuUGFyYW1zGlMKBlBhcmFtcxISCgpwcm9qZWN0X2lkGAEgASgJEhAKCGltYWdlX2lkGAIgASgJEhQKDGZyYW1lX251bWJlchgDIAEoCRINCgVmb3JjZRgEIAEoCCLyAgoiU2V0UHJvamVjdEltYWdlRnJhbWVOdW1iZXJSZXNwb25zZRJSCgZyZXN1bHQYASABKAsyQi5wcm90b3MudmlzaW9uLmFzc2V0cy52MS5TZXRQcm9qZWN0SW1hZ2VGcmFtZU51bWJlclJlc3BvbnNlLlJlc3VsdBrFAQoGUmVzdWx0ElYKB2FwcGxpZWQYASABKAsyQy5wcm90b3MudmlzaW9uLmFzc2V0cy52MS5TZXRQcm9qZWN0SW1hZ2VGcmFtZU51bWJlclJlc3BvbnNlLkFwcGxpZWRIABJYCghjb25mbGljdBgCIAEoCzJELnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLlNldFByb2plY3RJbWFnZUZyYW1lTnVtYmVyUmVzcG9uc2UuQ29uZmxpY3RIAEIJCgdvdXRjb21lGgkKB0FwcGxpZWQaJQoIQ29uZmxpY3QSGQoRZXhpc3RpbmdfaW1hZ2VfaWQYASABKAliBnByb3RvMw");

/**
 * @generated from message protos.vision.assets.v1.SetProjectImageFrameNumberRequest
 */
export type SetProjectImageFrameNumberRequest = Message<"protos.vision.assets.v1.SetProjectImageFrameNumberRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.SetProjectImageFrameNumberRequest.Params params = 1;
   */
  params?: SetProjectImageFrameNumberRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.SetProjectImageFrameNumberRequest.
 * Use `create(SetProjectImageFrameNumberRequestSchema)` to create a new message.
 */
export const SetProjectImageFrameNumberRequestSchema: GenMessage<SetProjectImageFrameNumberRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_project_image_frame_number, 0);

/**
 * @generated from message protos.vision.assets.v1.SetProjectImageFrameNumberRequest.Params
 */
export type SetProjectImageFrameNumberRequest_Params = Message<"protos.vision.assets.v1.SetProjectImageFrameNumberRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: string frame_number = 3;
   */
  frameNumber: string;

  /**
   * @generated from field: bool force = 4;
   */
  force: boolean;
};

/**
 * Describes the message protos.vision.assets.v1.SetProjectImageFrameNumberRequest.Params.
 * Use `create(SetProjectImageFrameNumberRequest_ParamsSchema)` to create a new message.
 */
export const SetProjectImageFrameNumberRequest_ParamsSchema: GenMessage<SetProjectImageFrameNumberRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_project_image_frame_number, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.SetProjectImageFrameNumberResponse
 */
export type SetProjectImageFrameNumberResponse = Message<"protos.vision.assets.v1.SetProjectImageFrameNumberResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.SetProjectImageFrameNumberResponse.Result result = 1;
   */
  result?: SetProjectImageFrameNumberResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.SetProjectImageFrameNumberResponse.
 * Use `create(SetProjectImageFrameNumberResponseSchema)` to create a new message.
 */
export const SetProjectImageFrameNumberResponseSchema: GenMessage<SetProjectImageFrameNumberResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_project_image_frame_number, 1);

/**
 * @generated from message protos.vision.assets.v1.SetProjectImageFrameNumberResponse.Result
 */
export type SetProjectImageFrameNumberResponse_Result = Message<"protos.vision.assets.v1.SetProjectImageFrameNumberResponse.Result"> & {
  /**
   * @generated from oneof protos.vision.assets.v1.SetProjectImageFrameNumberResponse.Result.outcome
   */
  outcome: {
    /**
     * @generated from field: protos.vision.assets.v1.SetProjectImageFrameNumberResponse.Applied applied = 1;
     */
    value: SetProjectImageFrameNumberResponse_Applied;
    case: "applied";
  } | {
    /**
     * @generated from field: protos.vision.assets.v1.SetProjectImageFrameNumberResponse.Conflict conflict = 2;
     */
    value: SetProjectImageFrameNumberResponse_Conflict;
    case: "conflict";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.vision.assets.v1.SetProjectImageFrameNumberResponse.Result.
 * Use `create(SetProjectImageFrameNumberResponse_ResultSchema)` to create a new message.
 */
export const SetProjectImageFrameNumberResponse_ResultSchema: GenMessage<SetProjectImageFrameNumberResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_project_image_frame_number, 1, 0);

/**
 * @generated from message protos.vision.assets.v1.SetProjectImageFrameNumberResponse.Applied
 */
export type SetProjectImageFrameNumberResponse_Applied = Message<"protos.vision.assets.v1.SetProjectImageFrameNumberResponse.Applied"> & {
};

/**
 * Describes the message protos.vision.assets.v1.SetProjectImageFrameNumberResponse.Applied.
 * Use `create(SetProjectImageFrameNumberResponse_AppliedSchema)` to create a new message.
 */
export const SetProjectImageFrameNumberResponse_AppliedSchema: GenMessage<SetProjectImageFrameNumberResponse_Applied> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_project_image_frame_number, 1, 1);

/**
 * @generated from message protos.vision.assets.v1.SetProjectImageFrameNumberResponse.Conflict
 */
export type SetProjectImageFrameNumberResponse_Conflict = Message<"protos.vision.assets.v1.SetProjectImageFrameNumberResponse.Conflict"> & {
  /**
   * @generated from field: string existing_image_id = 1;
   */
  existingImageId: string;
};

/**
 * Describes the message protos.vision.assets.v1.SetProjectImageFrameNumberResponse.Conflict.
 * Use `create(SetProjectImageFrameNumberResponse_ConflictSchema)` to create a new message.
 */
export const SetProjectImageFrameNumberResponse_ConflictSchema: GenMessage<SetProjectImageFrameNumberResponse_Conflict> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_project_image_frame_number, 1, 2);

